import { useEffect, useState } from 'react';
import { supabase } from '../supabase';

export interface Milestone {
  text: string;
  due_date?: string | null;
  met_at?: string | null;
}

export interface PlayerPlan {
  id: string;
  period_start: string;
  period_end: string;
  corner_priorities: Record<string, number> | null;
  milestones: Milestone[];
  review_date: string | null;
}

export function usePlayerPlan(playerId: string | undefined, refreshKey: number = 0) {
  const [plan, setPlan] = useState<PlayerPlan | null>(null);

  useEffect(() => {
    if (!playerId) return;
    void refreshKey;
    let cancelled = false;
    (async () => {
      try {
        const today = new Date().toISOString().slice(0, 10);
        const { data, error } = await supabase
          .from('development_plans')
          .select('id, period_start, period_end, corner_priorities, milestones, review_date')
          .eq('player_id', playerId)
          .lte('period_start', today)
          .gte('period_end', today)
          .order('period_start', { ascending: false })
          .limit(1)
          .maybeSingle();
        if (cancelled) return;
        if (error) { console.warn('[player plan] load failed', error.message); return; }
        if (!data) { setPlan(null); return; }
        const milestones: Milestone[] = Array.isArray(data.milestones)
          ? (data.milestones as Milestone[])
          : [];
        setPlan({
          id: String(data.id),
          period_start: String(data.period_start),
          period_end: String(data.period_end),
          corner_priorities: (data.corner_priorities as Record<string, number> | null) ?? null,
          milestones,
          review_date: data.review_date as string | null,
        });
      } catch (err) {
        if (!cancelled) console.warn('[player plan] threw', err);
      }
    })();
    return () => { cancelled = true; };
  }, [playerId, refreshKey]);

  return plan;
}
